// UnitSelect keeps the unit list honest about the chosen category.
//
// Not every unit makes sense for every material: a profile is charged per bar or per
// metre, glass and services per m², an accessory per unit or per metre. Offering "m2"
// on a profile would offer a price nothing computes. The <select> ships with every
// (category, unit) pair as an <option data-cat>, and this shows only the ones that
// belong to the category currently selected.
//
// Island Architecture: a light-DOM web component wrapping the <select>, so the select
// keeps taking part in the surrounding <form>.

export class UnitSelect extends HTMLElement {
  private select!: HTMLSelectElement;
  private categorySelect!: HTMLSelectElement;
  private options: HTMLOptionElement[] = [];

  connectedCallback(): void {
    const select = this.querySelector<HTMLSelectElement>("[data-unit-select]");
    // The category lives in a sibling field, so it is found by id within the same form.
    const categoryID = this.dataset["unitCategory"] ?? "category";
    const form = this.closest("form") ?? document;
    const categorySelect = form.querySelector<HTMLSelectElement>(`#${categoryID}`);
    if (!select || !categorySelect) return;

    this.select = select;
    this.categorySelect = categorySelect;
    this.options = Array.from(select.options);

    this.categorySelect.addEventListener("change", () => this.sync());
    this.sync();
  }

  private sync(): void {
    const category = this.categorySelect.value;
    let firstMatch: HTMLOptionElement | null = null;

    for (const opt of this.options) {
      const matches = opt.dataset["cat"] === category;
      // `disabled` as well as `hidden`: hiding alone still lets a keyboard user land
      // on the option in some browsers.
      opt.hidden = !matches;
      opt.disabled = !matches;
      if (matches && !firstMatch) firstMatch = opt;
    }

    // If what was selected no longer belongs to this category, fall to the first one
    // that does — leaving an invalid unit selected would submit a price nobody computes.
    const current = this.select.selectedOptions[0];
    if ((!current || current.dataset["cat"] !== category) && firstMatch) {
      this.select.value = firstMatch.value;
    }
  }
}
